var map = {
	"./en.ts": [
		99824
	],
	"./es.ts": [
		12307,
		307
	],
	"./index.ts": [
		68087
	],
	"./patientReferralForm/en.ts": [
		26763
	],
	"./patientReferralForm/es.ts": [
		32120,
		120
	],
	"./patientReferralForm/zh-CHS.ts": [
		9635,
		635
	],
	"./patientReferralForm/zh-TW.ts": [
		82754,
		754
	],
	"./selfServiceForm/en.ts": [
		74932
	],
	"./selfServiceForm/es.ts": [
		8223,
		223
	],
	"./selfServiceForm/zh-CHS.ts": [
		40504,
		504
	],
	"./selfServiceForm/zh-TW.ts": [
		6591,
		591
	],
	"./zh-CHS.ts": [
		5388,
		388
	],
	"./zh-TW.ts": [
		95787,
		787
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 109;
module.exports = webpackAsyncContext;